import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './NotificationCenter.css';

const NotificationCenter = ({ isOpen, onClose }) => {
  const [notificaciones, setNotificaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtro, setFiltro] = useState('todas'); // todas, no_leidas

  useEffect(() => {
    if (isOpen) {
      cargarNotificaciones();
    }
  }, [isOpen, filtro]);

  const cargarNotificaciones = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const params = filtro === 'no_leidas' ? '?no_leidas=true' : '';
      
      const response = await axios.get(
        `window.location.origin/api/notificaciones${params}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        setNotificaciones(response.data.notificaciones);
      }
    } catch (error) {
      console.error('Error cargando notificaciones:', error);
    } finally {
      setLoading(false);
    }
  };

  const marcarLeida = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `window.location.origin/api/notificaciones/${id}/marcar-leida`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      
      // Actualizar localmente
      setNotificaciones(prev => 
        prev.map(n => n.id === id ? { ...n, leida: true } : n)
      );
    } catch (error) {
      console.error('Error marcando notificación:', error);
    }
  };

  const marcarTodasLeidas = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        '/notificaciones/marcar-todas-leidas',
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      
      // Recargar
      cargarNotificaciones();
    } catch (error) {
      console.error('Error marcando todas:', error);
    }
  };

  const handleNotificacionClick = (notificacion) => {
    // Marcar como leída
    if (!notificacion.leida) {
      marcarLeida(notificacion.id);
    }
    
    // Navegar si tiene URL
    if (notificacion.accion_url) {
      window.location.href = notificacion.accion_url;
    }
    
    onClose();
  };

  const getIcono = (icono) => {
    const iconos = {
      'warning': '⚠️',
      'error': '🚨',
      'info': 'ℹ️',
      'success': '✅',
      'money': '💰',
      'user': '👤',
      'clock': '⏰'
    };
    return iconos[icono] || '🔔';
  };

  const getPrioridadClass = (prioridad) => {
    return `notif-prioridad-${prioridad}`;
  };

  const formatearFecha = (fecha) => {
    const date = new Date(fecha);
    const ahora = new Date();
    const diff = ahora - date;
    
    const minutos = Math.floor(diff / 60000);
    const horas = Math.floor(diff / 3600000);
    const dias = Math.floor(diff / 86400000);
    
    if (minutos < 1) return 'Ahora';
    if (minutos < 60) return `Hace ${minutos}m`;
    if (horas < 24) return `Hace ${horas}h`;
    return `Hace ${dias}d`;
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="notification-backdrop" onClick={onClose}></div>
      <div className="notification-center">
        <div className="notification-header">
          <h3>🔔 Notificaciones</h3>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>

        <div className="notification-filters">
          <button 
            className={filtro === 'todas' ? 'active' : ''}
            onClick={() => setFiltro('todas')}
          >
            Todas
          </button>
          <button 
            className={filtro === 'no_leidas' ? 'active' : ''}
            onClick={() => setFiltro('no_leidas')}
          >
            No leídas
          </button>
          <button 
            className="btn-marcar-todas"
            onClick={marcarTodasLeidas}
          >
            Marcar todas leídas
          </button>
        </div>

        <div className="notification-list">
          {loading ? (
            <div className="notification-loading">Cargando...</div>
          ) : notificaciones.length === 0 ? (
            <div className="notification-empty">
              <p>📭 No hay notificaciones</p>
            </div>
          ) : (
            notificaciones.map(notif => (
              <div 
                key={notif.id}
                className={`notification-item ${!notif.leida ? 'no-leida' : ''} ${getPrioridadClass(notif.prioridad)}`}
                onClick={() => handleNotificacionClick(notif)}
              >
                <div className="notif-icon">
                  {getIcono(notif.icono)}
                </div>
                <div className="notif-content">
                  <div className="notif-titulo">{notif.titulo}</div>
                  <div className="notif-mensaje">{notif.mensaje}</div>
                  <div className="notif-fecha">{formatearFecha(notif.created_at)}</div>
                </div>
                {!notif.leida && (
                  <div className="notif-badge"></div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default NotificationCenter;

